import { PRODUCT_NAME } from "../config"

// set browser page title and include product name
export const SetPageTitle = (title) => {
  let documentTitle = title ? title + ' | ' : '';
  documentTitle += PRODUCT_NAME;
   
  document.title = documentTitle; 
}